import i18n from '@/i18n';

/** 系统公告类型（Admin 选择 + 用户端弹窗共用） */
export const SYSTEM_ANNOUNCEMENT_STYLES = [
  {
    value: 'info',
    label: '常规通知',
    desc: '日常说明与运营提示',
    accent: '#2563eb',
    soft: 'rgba(37, 99, 235, 0.12)',
  },
  {
    value: 'update',
    label: '产品更新',
    desc: '功能迭代与版本更新',
    accent: '#7c3aed',
    soft: 'rgba(124, 58, 237, 0.12)',
  },
  {
    value: 'warning',
    label: '重要提醒',
    desc: '需用户关注的重要事项',
    accent: '#d97706',
    soft: 'rgba(217, 119, 6, 0.14)',
  },
  {
    value: 'success',
    label: '上新喜报',
    desc: '新功能上线与好消息',
    accent: '#059669',
    soft: 'rgba(5, 150, 105, 0.12)',
  },
  {
    value: 'promo',
    label: '优惠福利',
    desc: '折扣、赠送与限时优惠',
    accent: '#e11d48',
    soft: 'rgba(225, 29, 72, 0.12)',
  },
  {
    value: 'activity',
    label: '运营活动',
    desc: '限时活动与运营玩法',
    accent: '#0891b2',
    soft: 'rgba(8, 145, 178, 0.12)',
  },
];

export function getSystemAnnouncementStyleLabel(value) {
  const found = SYSTEM_ANNOUNCEMENT_STYLES.find((item) => item.value === value)
    || SYSTEM_ANNOUNCEMENT_STYLES[0];
  return i18n.t(`workbench:systemAnnouncementStyle.${found.value}`, {
    defaultValue: found.label,
  });
}

export function getSystemAnnouncementStyle(value) {
  return SYSTEM_ANNOUNCEMENT_STYLES.find((item) => item.value === value)
    || SYSTEM_ANNOUNCEMENT_STYLES[0];
}
